import { AttachInternalController } from "@nx-paeonia/utils-dom";
import { LitElement, type PropertyValues } from "lit";
import { property } from "lit/decorators.js";
import { html } from "lit-html";

export class ZipCodeDependantShippingComponent extends LitElement {
	static formAssociated = true;

	@property({ type: String, attribute: "default-shipping-id" })
	defaultShippingId: string | null = null;

	@property({ type: String, attribute: "local-shipping-id" })
	localShippingId: string | null = null;

	@property({ type: String, attribute: "input-selector" })
	inputSelector = 'input[name="shipping_costs"]';

	@property({
		type: Array,
		attribute: "local-shipping-zipcodes",
		converter: (value) => (value ? value.split(",").map((zip: string) => zip.trim()) : []),
	})
	localShippingZipCodes: string[] = [];

	constructor() {
		super();
		new AttachInternalController(this);
	}

	protected override firstUpdated(_changedProperties: PropertyValues) {
		super.firstUpdated(_changedProperties);

		if (!this.defaultShippingId) {
			throw new Error("No Default shipping ID provided.");
		}

		if (this.localShippingId && this.localShippingZipCodes.length > 0) {
			this.addEventListener("input", (event) => {
				const target = event.target as HTMLInputElement;
				const value = target.value.trim().split(" ").at(0)?.trim() ?? "";
				const inputElement = document.querySelector<HTMLInputElement>(this.inputSelector);
				if (!inputElement) {
					return;
				}

				if (this.localShippingZipCodes.includes(value)) {
					inputElement.value = this.localShippingId as string;
				} else {
					inputElement.value = this.defaultShippingId as string;
				}
			});
		}
	}

	protected override render() {
		return html`
      <slot></slot>
    `;
	}
}

export function defineZipCodeDependantShippingComponent(): void {
	if (!customElements.get("y-zip-code-dependant-shipping")) {
		customElements.define("y-zip-code-dependant-shipping", ZipCodeDependantShippingComponent);
	}
}
